import { gql } from "@apollo/client";

export const ProfileCoachingInsightFragment = gql`
  fragment ProfileCoachingInsightFragment on ManagerInsightNode {
    insightType
    title
    description
    relatedUrl
    suggestedArtifactTitle
    suggestedCoreValue {
      id
    }
  }
`;

export default gql`
  ${ProfileCoachingInsightFragment}
  query getProfileCoachingInsightsQuery($profileId: Int!) {
    user(userId: $profileId) {
      id
      managerInsights {
        edges {
          node {
            ...ProfileCoachingInsightFragment
          }
        }
      }
    }
  }
`;
